export default function GetImpactAcrossTimeText() {

    // -------------------
    // Section Explanations
    // -------------------

    const impactAcrossTimeOptions = [
        {
            id: 1,
            icon: 'broken-home-green.png',
            timeframe: 'Sudden',
            homepageTimeframe: 'Sudden Unforeseen Repairs',
            homepageTimeframeShort: 'Unforeseen Repairs',
            title: 'Unforeseen Fixes',
            description: "Costs you may not have budgeted for.",
            question: "What might I need to budget to cover unforeseen fixes?"
        },
        {
            id: 2,
            icon: 'home_bills.png',
            timeframe: 'Recurring',
            homepageTimeframe: 'Bills Like Insurance and Utilities',
            homepageTimeframeShort: 'Recurring Bills',
            title: 'General Expenses',
            description: 'Think insurance, maintenance, taxes, utilities etc.',
            question: "What happens to bills like insurance and utilities?"
        },
        {
            id: 3,
            icon: 'home-ltv-icon.png',
            timeframe: 'Long-Term',
            homepageTimeframe: 'Property Long-Term Market Value',
            homepageTimeframeShort: 'Long-Term Market Value',
            title: 'Market Value',
            description: 'What happens when you go to sell the property?',
            question: "What does this mean for my home's long-term value?"
        }
    ]

    return impactAcrossTimeOptions;

}